module.exports = __webpack_public_path__ + "static/media/golf1.45b5a33b.jpg";